import React, { useEffect, useState } from 'react'
import type { ReactPlayerProps } from 'react-player'

interface ClientOnlyPlayerProps extends ReactPlayerProps {

}

// https://github.com/cookpete/react-player/issues/142

const ClientOnlyReactPlayer: React.FC<ClientOnlyPlayerProps> = ({ url, ...props }) => {
    const [isClient, setIsClient] = useState(false)
    const isSSR = typeof window === "undefined"

    useEffect(() => {
        // this will only run in the browser
        setIsClient(true)
    }, [])

    if (isSSR || !isClient) {
        // skip rendering during SSR
        return <></>
    }

    // require react-player at runtime so it doesn't get bundled for SSR
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const ReactPlayerRuntime = require('react-player').default
    return <ReactPlayerRuntime url={url} {...props} />
}

export default ClientOnlyReactPlayer